import { registerMutation } from 'data-fetching-client';
import { setTosAcceptance } from '../api/TosApi';
export const SET_TOS_ACCEPTANCE = registerMutation({
  fieldName: 'tosAcceptance',
  fetcher: setTosAcceptance
});